import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ui-form-field-error',
  templateUrl: './form-field-error.component.html',
  styleUrls: ['./form-field-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class UIFormFieldErrorComponent {}
